import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-auto-renewal-modal',
  imports: [TranslateModule],
  templateUrl: './auto-renewal-modal.component.html',
  styleUrl: './auto-renewal-modal.component.scss'
})
export class AutoRenewalModalComponent {
  private dialog = inject(MatDialogRef<any>);
  public data = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    document.body.classList.add('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.removeAttribute('aria-hidden');
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.setAttribute('aria-hidden', 'true');
    }
  }

  beforeClose() {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
  }

  closeDialog(res?: any): void {
    this.beforeClose();
    this.dialog.close(res);
  }
}
